:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-column{flex-direction:column;}
:root ._width-10037{width:100%;}
:root ._fwr-wrap{flex-wrap:wrap;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._justify-center{justify-content:center;}
:root ._grow-1{flex-grow:1;}
:root ._items-center{align-items:center;}
:root ._mt-t-space-lar3294{margin-top:var(--t-space-large);}
:root ._mb-t-space-lar3294{margin-bottom:var(--t-space-large);}